export default __webpack_public_path__ + "static/media/PanzerGlass.638e87d8.svg";